import React, {useContext, useEffect, useState} from "react";
import styled from "styled-components";
import TableB from "./TableB";
import { FaRegWindowClose } from "react-icons/fa";
import ModuleSettings from "../utils/moduleSettings";
import { useNavigate } from "react-router-dom";
import LoadingPopup from "./LoadingPopup";

import { useGetCellInfoQuery } from "../store/apis/api";

export default function ResultsCell ({batchName, moduleName, cellName}) {
    const navigate = useNavigate();
    const settings = useContext(ModuleSettings);

    // Fetch cell info using RTK Query
    const { data, isLoading, error } = useGetCellInfoQuery({ batchName, moduleName, cellName });
    
    if (error) {
        console.error("Error fetching cell data:", error);
        sessionStorage.removeItem("tokens");
        navigate("/");
        return null;
    }

    const handleClose = async () => {
        settings.upDateSettings({'value1':false, 'value2':cellName});
    }
  
    return (
        <Container>
            { isLoading ? (
                <div className="container">
                    <LoadingPopup/>
                </div>
            ) : (

                <div className="container">
                <div className="header flex a-center">
                    <h1> Detailed analysis of the {cellName} cell from module {moduleName} </h1>
                    <div className="right">
                        <button onClick={handleClose}>
                            <FaRegWindowClose />
                        </button>
                    </div>
                </div>
                <div className="image-row">
                    <TableB 
                        data={data?.stats} 
                        title={'Analysis of ' + cellName} 
                        fileName={'Overview_of_cell_' + cellName} 
                        colours={data?.colours} 
                        textColours={data?.textColour} 
                        isCell={1}
                    />
                    <div className="img-container">
                        <h3> Defect map </h3>
                        <img src={`data:image/jpeg;base64,${data?.colourmap}`} alt="Colour map" />
                    </div>
                    <div className="img-container">
                        <h3> Original electroluminiscence image </h3>
                        <img src={`data:image/jpeg;base64,${data?.el}`} alt="Original EL" />
                    </div>
                </div>
            </div>
            )}
        </Container>
    )
}

const Container = styled.div`
height: 100vh;
width: 90vw;
left: 0;
top: 0;
.container {
    color: black;   
    .header {
        display: flex;
        flex-direction: row; 
        justify-content: space-between;    
        padding: 0 6rem;   
        align-items: center;
        h1 {
            text-align: center;
        }
        .right {            
            padding: 2rem;
            button {
                background-color: transparent;
                border: none;
                cursor: pointer;
                &:focus {
                  outline: none;
                }
                svg {
                  color: #f34242;
                  font-size: 2rem;
                }
            }
        }
    }    
    .image-row {
        display: flex;
        gap: 7rem;
        padding: 0rem 3rem;
        align-items: center;
        justify-content: center;
        .img-container {
            width = 25vw;
            color: black;
            background: white;
            align-items: start;
            justify-content: center;      
            text-align: center; 
            img {
                width: 20rem;
                height: 100%;
                z-index: 10;
            }
        }
    }
}
`;